export default "__VITE_ASSET__C1YvHLQ9__"